import type { FragmentOf } from "@opensea/graphql"
import { graphql, readFragment } from "@opensea/graphql"
import type { CurrencyIdentifier } from "../providers/CurrenciesProvider"

export const currencyIdentifierFragment = graphql(`
  fragment currencyIdentifier on ContractIdentifier {
    contractAddress
    chain {
      identifier
    }
  }
`)

export const getCurrencyIdentifier = (
  key: FragmentOf<typeof currencyIdentifierFragment>,
): CurrencyIdentifier => {
  const { contractAddress, chain } = readFragment(
    currencyIdentifierFragment,
    key,
  )
  return { contractAddress, chainIdentifier: chain.identifier }
}

export const isCurrencyIdentifierEqual = (
  a: CurrencyIdentifier | null | undefined,
  b: CurrencyIdentifier | null | undefined,
) => {
  if (!(a && b)) {
    return false
  }
  return (
    a.contractAddress.toLowerCase() === b.contractAddress.toLowerCase() &&
    a.chainIdentifier === b.chainIdentifier
  )
}

// Re-export getCurrencyKey from CurrenciesProvider for backward compatibility
export { getCurrencyKey } from "../providers/CurrenciesProvider"

export const recentlyCreatedCurrencyFragment = graphql(`
  fragment isRecentlyCreated on Currency {
    genesisDate
  }
`)

export function getIsRecentlyCreatedCurrency(
  key: FragmentOf<typeof recentlyCreatedCurrencyFragment>,
): boolean {
  const currency = readFragment(recentlyCreatedCurrencyFragment, key)
  const now = new Date()
  const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000) // 7 days in milliseconds
  const createdAt = currency.genesisDate
  return createdAt ? new Date(createdAt) > sevenDaysAgo : false
}
